var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProductTerpenes = function SvgIconProductTerpenes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    fillRule: "evenodd",
    d: "M9.177 2.5c.5-.526.823-.833.823-.833q.172.566.386 1.08c.846 2.028 2.16 3.49 3.33 4.793 1.365 1.518 2.534 2.82 2.534 4.543a6.25 6.25 0 0 1-12.5 0c0-3.47 3.73-7.794 5.427-9.583m.43 1.064a33 33 0 0 0-1.905 2.259c-.756.99-1.496 2.092-2.042 3.198-.552 1.117-.868 2.164-.868 3.062 0 0 2.604 1.563 5.208.521s5.208-.52 5.208-.52c0-1.252-.829-2.248-2.271-3.855l-.032-.033c-1.082-1.206-2.384-2.653-3.298-4.632",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    fillRule: "evenodd",
    d: "M6.41 9.767c.854-1.71 1.788-2.868 2.18-3.26l.737.737c-.302.302-1.175 1.365-1.986 2.99z",
    clipRule: "evenodd"
  })));
};
export default SvgIconProductTerpenes;